module.exports = __webpack_public_path__ + "static/Find Us Store 2-01-b25a49e449f3805b7812f0c087a08799.png";